import { extractHtmlError, fetchWithXsrf, getAntiForgeryToken } from "@siisel/frontend-shared";
import { useState } from "react";
import type { ResetPasswordFormViewModel } from "../types";

export default function ResetPasswordFormApp(props: ResetPasswordFormViewModel) {
  const [password, setPassword] = useState(props.values.password);
  const [confirmPassword, setConfirmPassword] = useState(props.values.confirmPassword);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  async function submit(root: HTMLElement | null) {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    setErrorMessage(null);

    try {
      const formData = new FormData();
      const token = getAntiForgeryToken(root);
      if (token) {
        formData.append("__RequestVerificationToken", token);
      }

      formData.append("UserId", String(props.values.userId));
      formData.append("Code", props.values.code);
      formData.append("Password", password);
      formData.append("ConfirmPassword", confirmPassword);

      const response = await fetchWithXsrf(props.submitUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "text/html"
        },
        body: formData
      });

      if (response.redirected) {
        window.location.href = response.url;
        return;
      }

      const html = await response.text();
      if (!response.ok) {
        throw new Error(html);
      }

      const validationMessage = extractHtmlError(html);
      if (validationMessage) {
        setErrorMessage(validationMessage);
        return;
      }

      window.location.reload();
    } catch (error) {
      const message = error instanceof Error ? error.message : "Ulozeni se nepodarilo.";
      setErrorMessage(message.includes("<") ? extractHtmlError(message) || message : message);
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="forms-app reset-password-form-app">
      {errorMessage ? <div className="alert alert-danger">{errorMessage}</div> : null}
      <div className="form-group">
        <label htmlFor="reset-password-password">{props.labels.password}</label>
        <input
          id="reset-password-password"
          className="form-control"
          type="password"
          value={password}
          disabled={isSubmitting}
          onChange={(event) => {
            setPassword(event.currentTarget.value);
            setErrorMessage(null);
          }}
        />
      </div>
      <div className="form-group">
        <label htmlFor="reset-password-confirm">{props.labels.confirmPassword}</label>
        <input
          id="reset-password-confirm"
          className="form-control"
          type="password"
          value={confirmPassword}
          disabled={isSubmitting}
          onChange={(event) => {
            setConfirmPassword(event.currentTarget.value);
            setErrorMessage(null);
          }}
        />
      </div>
      <button
        type="button"
        className="btn btn-block btn-lg btn-primary"
        disabled={isSubmitting}
        onClick={(event) => void submit(event.currentTarget.closest(".forms-app"))}
      >
        {isSubmitting ? `${props.submitText}...` : props.submitText}
      </button>
    </div>
  );
}
